module.exports = __webpack_public_path__ + "pf.e814e4c4e188e5218479.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/pf.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/pf.svg
// module chunks = styles